"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventPath = exports.calculateOffsets = exports.calculateAttachments = void 0;

var selectOther = function selectOther(current, options) {
  var other = options.filter(function (item) {
    return item !== current;
  });

  if (other.length === 1) {
    return other[0];
  }

  return current;
};

var addUnitIfNeeded = function addUnitIfNeeded(numOrString) {
  if (!numOrString) {
    return '0px';
  }

  if (typeof numOrString === 'number') {
    return numOrString + 'px';
  }

  return numOrString;
};

var positionToAttachment = function positionToAttachment(targetHorizontal, targetVertical) {
  var vertical = targetVertical;
  var horizontal = selectOther(targetHorizontal, ['top', 'bottom']);

  if (horizontal === 'middle') {
    vertical = selectOther(vertical, ['left', 'right']);
  }

  return {
    attachment: "".concat(horizontal, " ").concat(vertical),
    targetAttachment: "".concat(targetHorizontal, " ").concat(targetVertical)
  };
};

var calculateAttachments = function calculateAttachments(positionHorizontal, positionVertical) {
  var calculatedAttachments = {};

  if (positionHorizontal || positionVertical) {
    Object.assign(calculatedAttachments, positionToAttachment(positionHorizontal || 'bottom', positionVertical || 'left'));
  }

  return calculatedAttachments;
};

exports.calculateAttachments = calculateAttachments;

var calculateOffsets = function calculateOffsets(offset, shift, positionHorizontal, positionVertical) {
  var cOffset = addUnitIfNeeded(offset);
  var cShift = addUnitIfNeeded(shift);

  if (positionHorizontal === 'top') {
    return {
      offset: "".concat(cOffset, " ").concat(cShift)
    };
  } else if (positionHorizontal === 'bottom') {
    return {
      targetOffset: "".concat(cOffset, " ").concat(cShift)
    };
  }

  if (positionVertical === 'left') {
    return {
      offset: "".concat(cShift, " ").concat(cOffset)
    };
  } else if (positionVertical === 'right') {
    return {
      targetOffset: "".concat(cShift, " ").concat(cOffset)
    };
  }

  return {};
};

exports.calculateOffsets = calculateOffsets;

var getEventPath = function getEventPath(event) {
  var path = [];
  var node = event.target;

  do {
    path.push(node); // eslint-disable-next-line flowtype/no-weak-types

    node = node.parentNode;
  } while (node && node !== event.currentTarget);

  return path;
};

exports.getEventPath = getEventPath;
//# sourceMappingURL=utils.js.map